// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"vca-z","narrowOptionButtons":"wca-z","noOptions":"xca-z"};